const getNetRecurringBenefitChangeCategoryL4Plus = (initiative) => {
    const calculateL4PlusNetRecurringBenefit = (init) => {
      const l4Plus = ['L4', 'L5'];
      return calculateNetRecurringBenefitForStages(init, l4Plus);
    };
  
    const calculateNetRecurringBenefitForStages = (init, stages) => {
      const sumAnnuallyPlan = (value) => {
        if (Array.isArray(value)) {
          return value.reduce((sum, val) => sum + (val || 0), 0);
        }
        return value || 0;
      };
  
      const impacts = init.impact || [];
  
      if (!impacts || impacts.length === 0) {
        return NaN; // Indicate no impact
      }
  
      let recurringBenefit = 0;
      let negativeRecurringImpact = 0;
  
      if (init.stage) {
        if (Array.isArray(init.stage)) {
          if (init.stage.some((stage) => stages.includes(stage))) {
            recurringBenefit = impacts
              .filter((impact) => impact.frequencyAndDirection === 'Recurring benefits')
              .reduce((sum, impact) => sum + sumAnnuallyPlan(impact.annuallyPlan), 0);
  
            negativeRecurringImpact = impacts
              .filter((impact) => impact.frequencyAndDirection === 'Recurring Negative Impact (ETB)')
              .reduce((sum, impact) => sum + sumAnnuallyPlan(impact.annuallyPlan), 0);
          }
        } else if (typeof init.stage === 'string' && stages.includes(init.stage)) {
          recurringBenefit = impacts
            .filter((impact) => impact.frequencyAndDirection === 'Recurring benefits')
            .reduce((sum, impact) => sum + sumAnnuallyPlan(impact.annuallyPlan), 0);
  
          negativeRecurringImpact = impacts
            .filter((impact) => impact.frequencyAndDirection === 'Recurring Negative Impact (ETB)')
            .reduce((sum, impact) => sum + sumAnnuallyPlan(impact.annuallyPlan), 0);
        }
      }
  
      return recurringBenefit - negativeRecurringImpact;
    };
  
    const now = new Date();
    const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
  
    const calculateBenefitFunction = calculateL4PlusNetRecurringBenefit; // Always use L4+
  
    if (calculateBenefitFunction) {
      const history = initiative.history || [];
      const impactUpdateHistory = history.filter(
        (entry) =>
          entry.action &&
          entry.action.includes('Impact number') &&
          entry.action.includes('has been updated.')
      );
  
      const oldImpactHistories = impactUpdateHistory.filter(
        (entry) => new Date(entry.timestamp) < oneWeekAgo
      );
  
      oldImpactHistories.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
  
      let newNetRecurringBenefit = Array(5).fill(0);
      let previousNetRecurringBenefit = Array(5).fill(0);
  
      oldImpactHistories.forEach((entry) => {
        if (entry.changes && entry.changes.annuallyPlan && entry.changes.annuallyPlan.new) {
          if (entry.action.includes('Recurring benefits')) {
            for (let i = 0; i < 5; i++) {
              newNetRecurringBenefit[i] += entry.changes.annuallyPlan.new[i] || 0;
              previousNetRecurringBenefit[i] += entry.changes.annuallyPlan.previous[i] || 0;
            }
          } else if (entry.action.includes('Recurring Negative Impact (ETB)')) {
            for (let i = 0; i < 5; i++) {
              newNetRecurringBenefit[i] -= entry.changes.annuallyPlan.new[i] || 0;
              previousNetRecurringBenefit[i] -= entry.changes.annuallyPlan.previous[i] || 0;
            }
          }
        }
      });
  
      const totalNew = newNetRecurringBenefit.reduce((sum, value) => sum + value, 0);
      const totalPrevious = previousNetRecurringBenefit.reduce((sum, value) => sum + value, 0);
  
      const currentValue = calculateBenefitFunction(initiative);
      const lastWeekValue = totalNew;
  
      if (
        initiative.weeklyStatus === 'Cancelled' ||
        initiative.weeklyStatus === 'On hold' ||
        initiative.weeklyStatus === 'Rejected'
      ) {
        return 'Cancelled/On hold';
      } else if (
        isNaN(currentValue) &&
        isNaN(lastWeekValue) &&
        initiative.impact &&
        initiative.impact.length === 0
      ) {
        return 'New Initiative';
      } else if (isNaN(currentValue) || isNaN(lastWeekValue)) {
        return '<not set>';
      } else if (currentValue > lastWeekValue) {
        return 'Increased value';
      } else if (currentValue < lastWeekValue) {
        return 'Decreased value';
      } else if (currentValue === lastWeekValue) {
        return 'Unchanged';
      }
    }
  
    return '<not set>'; // Default if calculation fails or no benefit function
  };
  
  export default getNetRecurringBenefitChangeCategoryL4Plus;